export enum EOrgUserRole {
  ROLE_ORG_ADMIN = "ROLE_ORG_ADMIN",
  ROLE_ORG_VIEWER = "ROLE_ORG_VIEWER",
  ROLE_ORG_OPERATOR = "ROLE_ORG_OPERATOR",
  ROLE_ORG_GUEST = "ROLE_ORG_GUEST",
}
